<template>
  <v-app-bar absolute color="transparent" flat height="85">
    <v-container class="px-0 text-right d-flex align-center">
      <v-toolbar-title
        class="font-weight-light hidden-xs-only"
        v-text="title"
      />

      <v-spacer />

      <v-btn
        v-for="(item, i) in items"
        class="white--text ma-0"
        :key="i"
        :to="item.to"
        min-height="48"
        min-width="40"
        text
      >
        <v-icon
          class="pa-1 ma-3 "
          :left="$vuetify.breakpoint.mdAndUp"
          size="28"
          v-text="item.icon"
        />
        
        <span class="hidden-sm-and-down" v-text="item.text" />
      </v-btn>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: "externalAppBar",

  data: () => ({
    items: [
      // {
      //   icon: "mdi-view-dashboard",
      //   text: "Dashboard",
      //   to: "/dashboard",
      // },
      // {
      //   icon: "mdi-currency-usd",
      //   text: "Pricing",
      //   to: "/pages/pricing",
      // },
      // {
      //   icon: "mdi-account-multiple-plus",
      //   text: "Cadastrar",
      //   to: "/register",
      //   // to: "/add-resales",
      // },
      // {
      //   icon: "mdi-fingerprint",
      //   text: "Login",
      //   to: "/login",
      // },
      // {
      //   icon: "mdi-lock-open-outline",
      //   text: "Lock",
      //   to: "/pages/lock",
      // },
    ],
    titles: {
      // "/pages/lock": "Lock Page",
      "/pages/login": "Login Page",
      // "/pages/pricing": "Pricing Page",
      "/pages/register": "Register Page",
    },
  }),

  computed: {
    title() {
      return this.titles[this.$route.path];
    },
  },
};
</script>
